import { useRequest } from 'ahooks';
import { useEffect } from 'react';
import { useReadyInfo } from '@/providers/ReadyProvider';
import { fetchRefuseDesc } from '@/services/receipt';

/**
 * 小票审核拒绝原因
 */
const useRefuseDesc = () => {
  const { refuseDesc, setRefuseDesc } = useReadyInfo();

  const { run: getRefuseDesc, data, loading } = useRequest(fetchRefuseDesc, { manual: true });

  useEffect(() => {
    if (!refuseDesc || !refuseDesc?.length) {
      getRefuseDesc().then((res) =>
        setRefuseDesc(
          res?.reason_list?.map((reason) => {
            return {
              label: reason.name,
              value: reason.id,
            };
          }) ?? []
        )
      );
    }
  }, [refuseDesc]);

  return {
    data:
      refuseDesc ||
      (data?.reason_list?.map((reason) => {
        return {
          label: reason.name,
          value: reason.id,
        };
      }) ??
        []),
    loading,
  };
};

export default useRefuseDesc;
